import classes from './P2PAdminPanel.module.css';
import SidebarHeader from './SidebarHeader';
import SidebarList from './SidebarList';

const P2PSidebar: React.FC<{}> = () => {
    return (
        <div className={`${classes['wrap']} ${classes['sidebar-container']}`}>
            <SidebarHeader />
            <SidebarList />
        </div>
    );
};
export default P2PSidebar;
